import React from 'react';
import SelectedProductsBlock from './selected-products-block';

function SelectedProductsSection() {
    return (
        <div className="selected-products">
            <SelectedProductsBlock listType={'top_rated'} title={'Top Rated Products'}/>
            <SelectedProductsBlock listType={'best_selling'} title={'Best Selling Products'}/>
            <SelectedProductsBlock listType={'latest'} title={'Latest Products'}/>
        </div>
    );
}

export default React.memo(SelectedProductsSection);
